module.exports = __webpack_public_path__ + "static/media/slider-arrow-right.0988895c.svg";